import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileCheck2 } from 'lucide-react';
import { LoginForm } from './LandingPage';

// Dedicated /login page — focused login card on the same brand-gradient background
// used across the marketing site. Reuses the LoginForm from the landing page for
// zero UI drift.
export const LoginPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative overflow-hidden bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-testid="login-page">
      {/* Ambient background flourishes (same as landing hero) */}
      <div className="absolute inset-0 opacity-[0.06]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Cg fill='%23ffffff'%3E%3Ccircle cx='1' cy='1' r='1'/%3E%3C/g%3E%3C/svg%3E")`,
      }} />
      <div className="absolute top-1/4 right-1/4 w-80 h-80 bg-blue-500/20 rounded-full blur-[120px]" />
      <div className="absolute bottom-1/4 left-1/6 w-96 h-96 bg-indigo-500/15 rounded-full blur-[140px]" />

      {/* Top nav */}
      <nav className="relative z-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto h-14 flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2" data-testid="nav-home-link">
            <div className="p-1.5 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-lg">
              <FileCheck2 className="h-4 w-4 text-white" />
            </div>
            <span className="font-heading font-bold text-lg text-white">TestGenie AI</span>
          </button>
          <button onClick={() => navigate('/pricing')} className="text-sm text-blue-200 hover:text-white font-medium transition-colors" data-testid="nav-pricing-link">
            Pricing
          </button>
        </div>
      </nav>

      {/* Centered login card */}
      <main className="relative z-10 flex items-center justify-center px-4 py-10 sm:py-16">
        <LoginForm />
      </main>
    </div>
  );
};
